// console.log('%c 📦Loading minimalism_bundles...', 'color: yellow;')
var iso2 = 'ES';
let total_bundle_price = 0;
if(document.getElementById("loc-iso2")) {
  iso2 = document.getElementById("loc-iso2").getAttribute('content');
}

// var get_variants_url = "https://minimalism-bundles-5b91dfc47543.herokuapp.com/api/get_product_variants?pid=";
// var get_variants_url = "https://pango-bundles-coupon.cap.pangostudio.com/api/get_product_variants?pid=";
var get_variants_url = "https://pango-bundles-coupon.stgcap.pangostudio.com/api/get_product_variants?pid=";

var loadScript = function (url, callback) {
  /* JavaScript that will load the jQuery library on Google's CDN.
     We recommend this code: http://snipplr.com/view/18756/loadscript/.
     Once the jQuery library is loaded, the function passed as argument,
     callback, will be executed.  */
};

var myAppJavaScript = function ($) {
  /* Your app's JavaScript here.
     $ in this scope references the jQuery object we'll use.
     Don't use 'jQuery', or 'jQuery191', here. Use the dollar sign
     that was passed as argument.*/
  //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
};

if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
  loadScript(
    "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
    function () {
      jQuery191 = jQuery.noConflict(true);
      myAppJavaScript(jQuery191);
    }
  );
} else {
  myAppJavaScript(jQuery);
}

jQuery.fn.jquery;

/* ----------------------------------------------------------------------------------------------    
  MAGIA
  Esta es la parte que agrega al carrito el contenido del bundle
----------------------------------------------------------------------------------------------*/
function checkCookieLife(cookieName) {  
  //expiración para la cookie
  let timeCreation =  new Date(localStorage.addedBundlesTime);
  let currentTime = new Date();
  let maxDifference = 180; //minutos
  let currentDifference = currentTime - timeCreation;
  let minutesDifference = Math.floor(currentDifference/60000);

  console.log(`minutesDifference ${minutesDifference} >  maxDifference ${maxDifference} antes de borrar currentDifference ${currentDifference}`,localStorage.addedBundles);
  
  if(minutesDifference > maxDifference) {
    console.log(`${minutesDifference} > ${maxDifference} borramos addedBundles`,localStorage.addedBundles);
     localStorage.setItem("addedBundles", "");
    console.log(localStorage.addedBundles);
  }
}

// ------------------------------------------ 
function minimalism_bundles_add_to_cart(product_id) {
  checkCookieLife("addedBundles");
  var array_added_bundles = localStorage.getItem("addedBundles");
  var product_parent_id = jQuery("#minimalism-bundles-parent-id").val();
  //console.log('antes');
  //console.log(array_added_bundles);
  if (!array_added_bundles) {
    array_added_bundles = [];
  } else {
    array_added_bundles = JSON.parse(array_added_bundles);
  }
  //console.log('después');
  //console.log(array_added_bundles);
  if (!array_added_bundles.includes(product_parent_id)) {
    array_added_bundles.push(product_parent_id);
  }

  localStorage.addedBundles = JSON.stringify(array_added_bundles);
  localStorage.addedBundlesTime = new Date();

  console.log(localStorage.addedBundles);

  //Get variant id from Select
  //var variant_id = '36813283623079';
  //Ajax request to add special item to cart

  // Forzamos la redirección al carrito

  var list_of_ids = "";
  //console.log(variant_id);
  //console.log(jQuery("#quantity_"+variant_id).val());
  //console.log(jQuery("#price_"+variant_id).val());
  //For each variant we select one by quantity
  var quantity = jQuery("#quantity_" + product_id).val();
  list_of_ids = list_of_ids + "," + product_id;
  for (i = 0; i < quantity; i++) {
    var variant_id = jQuery(
      "select[name=bundle_select_" + product_id + "_" + i + "] option"
    )
      .filter(":selected")
      .val();
    jQuery("#aux_skus").val(jQuery("#aux_skus").val() + variant_id + ",");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: jQuery("#quantity_" + variant_id).val(),
        price: jQuery("#price_" + product_id).val(),
        id: variant_id,
      },
      async: false,
    });
  }
}

// ------------------------------------------
function minimalism_bundle() {
  var bundle_products = JSON.parse(jQuery("#minimalism-bundles-data").val());
  //console.log(bundle_products);
  for (var pr in bundle_products) {
    //console.log(pr);
    //console.log(bundle_products[pr]);
    var product_in_bundle = bundle_products[pr];
    minimalism_bundles_add_to_cart(product_in_bundle.id);
  }

  jQuery(".btn--add-to-cart").click(function () {
    //alert('Click añadir');
    minimalism_bundle();
  });
}

//---------------------------------------
//buscar idioma en la url
function get_current_lang_slug() {
  // IMPORTANTEEEEEEEEEEEEEEEEEEEE!!!!!!!!!!!!!!! SI VAS A AÑADIR ALGUN IDIOMA 
  //'/en-loquesea' ASEGURATE DE PONERLO DESPUES DE '/en' O NO VA A FUNCIONAR
  var langs_slugs = ['/es-mx', '/es-gb', '/en', '/en-us', '/en-de', '/en-gb', '/en-ca', '/en-int', '/de-de'];
    var slug_position = null;
    var current_lang_slug = '';
    var url = window.location.href;
    langs_slugs.forEach(lang_slug => {
        slug_position = url.search(lang_slug);
      
        // console.log("%c lang_slug  + slug_position: ",'color: yellow;', lang_slug, slug_position);
        
      
        if(slug_position > 0) {
          current_lang_slug = lang_slug;
        }
        return current_lang_slug;
    });
    return current_lang_slug;
}

//---------------------------------------
var current_lang_slug = get_current_lang_slug();
var form_selector_form_name = current_lang_slug + '/cart/add';
var form_selector = '[action="' + form_selector_form_name + '"]';
//---------------------------------------

/* ----------------------------------------------------------------------------------------------    
  PRODUCT PAGE FORM
----------------------------------------------------------------------------------------------*/
function minimalism_print_bundles_form() {
  // console.log('%c dentro: minimalism_print_bundles_form()', 'color: yellow;')
  
  if (jQuery("#minimalism-bundles-data").val() != null) {

    //".product-form__cart-submit"
    var button_selector = ".btn--add-to-cart";
    var div_group_selector_base = "minimalism-bundles-form-group";
    var bundle_products = JSON.parse(jQuery("#minimalism-bundles-data").val());
    // console.log('%c - Bundle_products:', 'color: yellow;', bundle_products);

    jQuery.ajaxSetup({
      async: false,
    });
    
    for (var pr in bundle_products) {
      var product_in_bundle = bundle_products[pr];
      var div_group_selector = div_group_selector_base + "_" + product_in_bundle.id;

      // console.log('%c - product_in_bundle', 'color: yellow;' ,product_in_bundle)
      
      jQuery(form_selector).prepend(
        '<div class="minimalism-bundles-form-group" id="' +
          div_group_selector +
          '"></div>'
      );
      
      //title
      var product_in_bundle___title = product_in_bundle.title;
      if(document.documentElement.lang == 'en') {
        //Array traducciones (cutre)
        var tranlations = {
          'Sudadera algodón orgánico con capucha' : 'Organic cotton hoodie',
          'Sudadera algodón orgánico' : 'Organic cotton sweatshirt',
          'Camiseta algodón orgánico' : 'Organic cotton T-shirt',
          'Calzoncillos Orgánicos' : 'Organic Briefs',
          'Calcetines Orgánicos' : 'Organic Socks',
          'Calcetines Orgánicos tobilleros' : 'Organic ankle socks',
          'Tanga Minimalism' : 'Minimalism Thong',
          'Culotte Minimalism' : 'Culotte Minimalism',
          'Camiseta algodón orgánico · Mujer' : 'Organic cotton T-shirt Woman',
          'Gel sólido uso diario' : 'Daily use solid gel',
          'Champú sólido uso diario' : 'Solid shampoo daily use',
          'Guantes de algodón reciclado' : 'Recycled cotton gloves',
          'Gorro de algodón reciclado' : 'Recycled cotton hat',
          'Bralette Minimalism' : 'Minimalism Bralette' ,
        };
        //Traducciones reemplazando texto
        product_in_bundle___title = product_in_bundle___title.replace(product_in_bundle___title,tranlations[product_in_bundle___title]);
      }
      jQuery("#" + div_group_selector).append(
        '<div id="' +
          div_group_selector +
          '__link-wrapper"><div id="' +
          div_group_selector +
          '__link"><a href="">' +
          product_in_bundle.quantity +
          "x " +
          product_in_bundle___title +
          "</a></div></div>"
      );
      jQuery("#" + div_group_selector).append(
        '<input name="updates[' +
          product_in_bundle.id +
          ']" class="quantity field" min="0" type="hidden" value="0" tabindex="1" />'
      );
      jQuery("#" + div_group_selector).append(
        '<input id="quantity_' +
          product_in_bundle.id +
          '" name="quantity_' +
          product_in_bundle.id +
          '" value="' +
          product_in_bundle.quantity +
          '" type="hidden"/>'
      );
      jQuery("#" + div_group_selector).append(
        '<input id="price_' +
          product_in_bundle.id +
          '" name="price_' +
          product_in_bundle.id +
          '" value="' +
          product_in_bundle.price +
          '" type="hidden"/></div>'
      );
      var quantity = product_in_bundle.quantity;

      for (aux_quantity = 0; aux_quantity < quantity; aux_quantity++) {
        //console.log(aux_quantity);
        var identificator =  "#bundle_select_" + product_in_bundle.id + "_" + aux_quantity;
        //console.log(identificator);
        jQuery("#" + div_group_selector).append(
          '<div class="' +
            div_group_selector +
            '__select-wrapper"><select name="bundle_select_' +
            product_in_bundle.id +
            "_" +
            aux_quantity +
            '" id="' +
            identificator +
            '" value="' +
            product_in_bundle.quantity +
            '" class="bundle_select_' +
            product_in_bundle.id +
            ' minimalism_product_bundles_variant_select" type="text"/>'
        );

        jQuery("#" + div_group_selector).append("</select></div>");
      }
      //const preurl = 'https://a33c26b995a13367ca64c4cb869b8d62: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@minimalismbrand.com';
      //var product_in_bundle_url = preurl + '/admin/api/2020-10/products/'+product_in_bundle.id+'/variants.json';
      //alert(product_in_bundle_url);
      //PROBLEMA  preurl + '/admin/api/2020-10/products/'+product_in_bundle.id+'/variants.json'

      jQuery.getJSON(
        get_variants_url + product_in_bundle.id + "&lang=" + document.documentElement.lang + "&qt=" + product_in_bundle.quantity + '&mk=' + iso2,
        function (variants) {
          // console.log("%c -dentro get product variants", 'color:yellow', variants );
          
          total_bundle_price = total_bundle_price + Number(variants.price);
          $('.was-price').text($('.was-price').text()[0]+total_bundle_price.toFixed(2))    
 
          for (var variant_index in variants.variants) {
            
            if (variants.variants[variant_index].title == "Default Title") {
              variants.variants[variant_index].title = "Único";
            }
            var identificator =
              "#bundle_select_" +
              variants.variants[variant_index].product_id +
              "_" +
              aux_quantity;
  
            var selector_select = "." + "bundle_select_" + product_in_bundle.id;
            jQuery(selector_select).append(
              '<option value="' +
                variants.variants[variant_index].id +
                '" sku="' +
                variants.variants[variant_index].sku +
                '">' +
                variants.variants[variant_index].title +
                "</option>"
            );
 
          } // end: for loop
        } // end : function (variants)
      ); // end : jQuery.getJSON(
    } // end : for (var pr in bundle_products) 
    
    //Añadimos el id del producto bundle actual que se guardará en una cookie
 
    //var minimalism_bundles_parent_id = jQuery('#minimalism-bundles-parent-id').val();
    //jQuery(form_selector).append('<input id="minimalism_bundle_parent_product_id" name="minimalism_bundle_parent_product_id" value="'+minimalism_bundles_parent_id+'" type="hidden"/></div>');

    //jQuery('.shopify-product-form').append('<button class="minimalism_bundle_add_to_cart">Añadir al carrito Pack</button>');

    //jQuery( form_selector ).submit(minimalism_bundle());

    //jQuery(button_selector).click(minimalism_bundle);
  }
} // end function minimalism_print_bundles_form()

// ------------------------------------------
function wait(ms){
   var start = new Date().getTime();
   var end = start;
   while(end < start + ms) {
     end = new Date().getTime();
  }
}

// ------------------------------------------
//https://community.shopify.com/c/Shopify-Design/Adding-2-products-to-cart-with-1-add-to-cart-button/td-p/272910
jQuery(document).ready(function() {
    // console.log('%c ??????', 'color: yellow;')
  
    //Detect if is a bundle
    var url = window.location.href;
    minimalism_print_bundles_form();

    /*CART*/
    var firstChange = true;

    function reloadCart() {
        var target = document.querySelector(`[data-cart-subtotal]`);

        if (!target) return;

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (firstChange) {
                    firstChange = false;
                    return;
                } else {
                    setTimeout(window.location.reload(), 100);
                }
            });
        });

        var config = {
            attributes: true,
            childList: true,
            characterData: true
        };
        observer.observe(target, config);
    }
    document.addEventListener("DOMContentLoaded", function() {
        reloadCart();
    });

    //CAPA DE CARGA
    if (document.getElementById("minimalism-add-to-cart") && jQuery("#minimalism-bundles-data").val()) {

        document.getElementById("minimalism-add-to-cart").addEventListener('click', function(e) {
            e.preventDefault();
            //meto capa de carga
            document.getElementById('minimalism-loagind-layer-bundles').style.display = 'block';
            console.log(e);

            setTimeout(function() {
                var cookie =
                          getCookie("minimalism-bundles-parent-id") +
                          "," +
                          jQuery("#minimalism-bundles-parent-id").val();
                          setCookie("minimalism-bundles-parent-id", cookie, 1);

                //Quitamos el producto pack del carrito
                jQuery.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: {
                        quantity: 0,
                        //tomamos el id del producto actual
                        id: jQuery(".shopify-product-form input[name=id]").val(),
                    },
                    async: true,
                });

                minimalism_bundle();
                location.href = current_lang_slug + "/cart";

            }, 1000);

        }, true)
    }
});
 



//------------------------------------------------
// si funciona todo, borrar esto de abajo 09-10-24
//------------------------------------------------
// console.log("Loading minimalism_bundles...");
// var iso2 = 'ES';
// let total_bundle_price = 0;
// if(document.getElementById("loc-iso2")) {
//   iso2 = document.getElementById("loc-iso2").getAttribute('content');
// }

// // var get_variants_url = "https://pango-bundles-coupon.cap.pangostudio.com/api/get_product_variants?pid=";
// var get_variants_url = "https://pango-bundles-coupon.stgcap.pangostudio.com/api/get_product_variants?pid=";
// // var get_variants_url = "https://minimalism-bundles-5b91dfc47543.herokuapp.com/api/get_product_variants?pid=";

// var loadScript = function (url, callback) {
//   /* JavaScript that will load the jQuery library on Google's CDN.
//      We recommend this code: http://snipplr.com/view/18756/loadscript/.
//      Once the jQuery library is loaded, the function passed as argument,
//      callback, will be executed.  */
// };

// var myAppJavaScript = function ($) {
//   /* Your app's JavaScript here.
//      $ in this scope references the jQuery object we'll use.
//      Don't use 'jQuery', or 'jQuery191', here. Use the dollar sign
//      that was passed as argument.*/
//   //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
// };

// if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
//   loadScript(
//     "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
//     function () {
//       jQuery191 = jQuery.noConflict(true);
//       myAppJavaScript(jQuery191);
//     }
//   );
// } else {
//   myAppJavaScript(jQuery);
// }

// jQuery.fn.jquery;
// function checkCookieLife(cookieName) {
//   //expiración para la cookie
//   let timeCreation =  new Date(localStorage.addedBundlesTime);
//   let currentTime = new Date();
//   let maxDifference = 180; //minutos
//   let currentDifference = currentTime - timeCreation;
//   let minutesDifference = Math.floor(currentDifference/60000);

//   console.log(`minutesDifference ${minutesDifference} >  maxDifference ${maxDifference} antes de borrar currentDifference ${currentDifference}`,localStorage.addedBundles);
//   console.log('Victoria');
//   if(minutesDifference > maxDifference) {
//     console.log(`${minutesDifference} > ${maxDifference} borramos addedBundles`,localStorage.addedBundles);
//      localStorage.setItem("addedBundles", "");
//     console.log(localStorage.addedBundles);
//   }
// }
// function minimalism_bundles_add_to_cart(product_id) {
//   //Añadir al carrito THEME NUEVO
  
//   /*
    
//     MAGIA
//     Esta es la parte que agrega al carrito el contenido del bundle
    
    
//     */

//   //console.log('preventDefault');
//   //alert('Click añadir');
//   //e.preventDefault();
//   checkCookieLife("addedBundles");
//   var array_added_bundles = localStorage.getItem("addedBundles");
//   var product_parent_id = jQuery("#minimalism-bundles-parent-id").val();
//   //console.log('antes');
//   //console.log(array_added_bundles);
//   if (!array_added_bundles) {
//     array_added_bundles = [];
//   } else {
//     array_added_bundles = JSON.parse(array_added_bundles);
//   }
//   //console.log('después');
//   //console.log(array_added_bundles);
//   if (!array_added_bundles.includes(product_parent_id)) {
//     array_added_bundles.push(product_parent_id);
//   }

//   localStorage.addedBundles = JSON.stringify(array_added_bundles);
//   localStorage.addedBundlesTime = new Date();

//   console.log(localStorage.addedBundles);

//   //Get variant id from Select

//   //var variant_id = '36813283623079';
//   //Ajax request to add special item to cart
//   /*
    
//     Forzamos la redirección al carrito
    
//     */
//   var list_of_ids = "";
//   //console.log(variant_id);
//   //console.log(jQuery("#quantity_"+variant_id).val());
//   //console.log(jQuery("#price_"+variant_id).val());
//   //For each variant we select one by quantity
//   var quantity = jQuery("#quantity_" + product_id).val();
//   list_of_ids = list_of_ids + "," + product_id;
//   for (i = 0; i < quantity; i++) {
//     var variant_id = jQuery(
//       "select[name=bundle_select_" + product_id + "_" + i + "] option"
//     )
//       .filter(":selected")
//       .val();
//     jQuery("#aux_skus").val(jQuery("#aux_skus").val() + variant_id + ",");
//     jQuery.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         quantity: jQuery("#quantity_" + variant_id).val(),
//         //quantity: 1,
//         price: jQuery("#price_" + product_id).val(),
//         //price: 1,
//         id: variant_id,
//       },
//       async: false,
//     });
//   }
//   //alert(list_of_ids);
//   //Ajax Request to add current product page to cart
//   /*jQuery.ajax({
//       type: "POST",
//       url: '/cart/add.js',
//       data: jQuery('form[action="/cart/add"]').serialize(),
//       async: false,
//       success: function(){
            
//           }
//     })*/
// }

// function minimalism_bundle() {
//   var bundle_products = JSON.parse(jQuery("#minimalism-bundles-data").val());
//   //console.log(bundle_products);
//   for (var pr in bundle_products) {
//     //console.log(pr);
//     //console.log(bundle_products[pr]);
//     var product_in_bundle = bundle_products[pr];
//     minimalism_bundles_add_to_cart(product_in_bundle.id);
//   }

//   jQuery(".btn--add-to-cart").click(function () {
//     //alert('Click añadir');
//     minimalism_bundle();
//   });
// }

// function get_current_lang_slug() {
//   //buscar idioma en la url
//   var langs_slugs = ['/en-int', '/en-us'];
//     var slug_position = null;
//     var current_lang_slug = '';
//     var url = window.location.href;
//     langs_slugs.forEach(lang_slug => {
//         slug_position = url.search(lang_slug);
//         console.log(lang_slug, slug_position);
//         if(slug_position > 0) {
//           current_lang_slug = lang_slug;
//         }
//         return current_lang_slug;
//     });
//     return current_lang_slug;
// }
// //'.product-form'
// var current_lang_slug = get_current_lang_slug();
// var form_selector_form_name = current_lang_slug + '/cart/add';
// var form_selector = '[action="' + form_selector_form_name + '"]';


// function minimalism_print_bundles_form() {
  
//   if (jQuery("#minimalism-bundles-data").val() != null) {
    
    
    
    
    

    
//     //".product-form__cart-submit"
//     var button_selector = ".btn--add-to-cart";
//     var div_group_selector_base = "minimalism-bundles-form-group";
//     var bundle_products = JSON.parse(jQuery("#minimalism-bundles-data").val());
//     console.log(bundle_products);
//     jQuery.ajaxSetup({
//       async: false,
//     });
//     for (var pr in bundle_products) {
//       //console.log(pr);
//       //console.log(bundle_products[pr]);
//       var product_in_bundle = bundle_products[pr];
//       var div_group_selector =
//         div_group_selector_base + "_" + product_in_bundle.id;
//       console.log("Minimalism Bundles loader in theme");
//       //jQuery('#ProductSelect-product-template').append('<option value="'+product_in_bundle.id+'" selected="selected">'+product_in_bundle.id+' </option>');
//       //console.log('group: '+div_group_selector);
//       jQuery(form_selector).prepend(
//         '<div class="minimalism-bundles-form-group" id="' +
//           div_group_selector +
//           '"></div>'
//       );
//       //title
//       var product_in_bundle___title = product_in_bundle.title;
//       if(document.documentElement.lang == 'en') {
//         //Array traducciones (cutre)
//         var tranlations = {
//           'Sudadera algodón orgánico con capucha' : 'Organic cotton hoodie',
//           'Sudadera algodón orgánico' : 'Organic cotton sweatshirt',
//           'Camiseta algodón orgánico' : 'Organic cotton T-shirt',
//           'Calzoncillos Orgánicos' : 'Organic Briefs',
//           'Calcetines Orgánicos' : 'Organic Socks',
//           'Calcetines Orgánicos tobilleros' : 'Organic ankle socks',
//           'Tanga Minimalism' : 'Minimalism Thong',
//           'Culotte Minimalism' : 'Culotte Minimalism',
//           'Camiseta algodón orgánico · Mujer' : 'Organic cotton T-shirt Woman',
//           'Gel sólido uso diario' : 'Daily use solid gel',
//           'Champú sólido uso diario' : 'Solid shampoo daily use',
//           'Guantes de algodón reciclado' : 'Recycled cotton gloves',
//           'Gorro de algodón reciclado' : 'Recycled cotton hat',
//           'Bralette Minimalism' : 'Minimalism Bralette' ,
//         };
//         //Traducciones reemplazando texto
//         product_in_bundle___title = product_in_bundle___title.replace(product_in_bundle___title,tranlations[product_in_bundle___title]);
//       }
//       jQuery("#" + div_group_selector).append(
//         '<div id="' +
//           div_group_selector +
//           '__link-wrapper"><div id="' +
//           div_group_selector +
//           '__link"><a href="">' +
//           product_in_bundle.quantity +
//           "x " +
//           product_in_bundle___title +
//           "</a></div></div>"
//       );
//       jQuery("#" + div_group_selector).append(
//         '<input name="updates[' +
//           product_in_bundle.id +
//           ']" class="quantity field" min="0" type="hidden" value="0" tabindex="1" />'
//       );
//       jQuery("#" + div_group_selector).append(
//         '<input id="quantity_' +
//           product_in_bundle.id +
//           '" name="quantity_' +
//           product_in_bundle.id +
//           '" value="' +
//           product_in_bundle.quantity +
//           '" type="hidden"/>'
//       );
//       jQuery("#" + div_group_selector).append(
//         '<input id="price_' +
//           product_in_bundle.id +
//           '" name="price_' +
//           product_in_bundle.id +
//           '" value="' +
//           product_in_bundle.price +
//           '" type="hidden"/></div>'
//       );
//       var quantity = product_in_bundle.quantity;

//       for (aux_quantity = 0; aux_quantity < quantity; aux_quantity++) {
//         //console.log(aux_quantity);
//         var identificator =
//           "#bundle_select_" + product_in_bundle.id + "_" + aux_quantity;
//         //console.log(identificator);
//         jQuery("#" + div_group_selector).append(
//           '<div class="' +
//             div_group_selector +
//             '__select-wrapper"><select name="bundle_select_' +
//             product_in_bundle.id +
//             "_" +
//             aux_quantity +
//             '" id="' +
//             identificator +
//             '" value="' +
//             product_in_bundle.quantity +
//             '" class="bundle_select_' +
//             product_in_bundle.id +
//             ' minimalism_product_bundles_variant_select" type="text"/>'
//         );

//         jQuery("#" + div_group_selector).append("</select></div>");
//       }
//       //const preurl = 'https://a33c26b995a13367ca64c4cb869b8d62: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@minimalismbrand.com';
//       //var product_in_bundle_url = preurl + '/admin/api/2020-10/products/'+product_in_bundle.id+'/variants.json';
//       //alert(product_in_bundle_url);
//       //PROBLEMA  preurl + '/admin/api/2020-10/products/'+product_in_bundle.id+'/variants.json'

//       jQuery.getJSON(
//         get_variants_url + product_in_bundle.id + "&lang=" + document.documentElement.lang + "&qt=" + product_in_bundle.quantity + '&mk=' + iso2,
//         function (variants) {
//           total_bundle_price = total_bundle_price + Number(variants.price);
//           $('.was-price').text($('.was-price').text()[0]+total_bundle_price.toFixed(2))
//           //console.log('product_in_bundle');
//           //console.log(product_in_bundle.id);
//           console.log("dentro get product variants");
//           console.log(variants.variants[0]);
//           //console.log(variants);
//           for (var variant_index in variants.variants) {
//             if (variants.variants[variant_index].title == "Default Title") {
//               variants.variants[variant_index].title = "Único";
//             }
//             var identificator =
//               "#bundle_select_" +
//               variants.variants[variant_index].product_id +
//               "_" +
//               aux_quantity;

//             //console.log(identificator);
//             //console.log(aux_quantity);

//             var selector_select = "." + "bundle_select_" + product_in_bundle.id;
//             jQuery(selector_select).append(
//               '<option value="' +
//                 variants.variants[variant_index].id +
//                 '" sku="' +
//                 variants.variants[variant_index].sku +
//                 '">' +
//                 variants.variants[variant_index].title +
//                 "</option>"
//             );
//             console.log('for each variant step minimalism bundles');
//             //console.log('variant');
//             //console.log(variants.variants[variant_index]);
//           }
//           //console.log(variants);
//           console.log('for each product step minimalism bundles');
//         }
//       );
//     }
//     //Añadimos el id del producto bundle actual que se guardará en una cookie
//     //console.log(minimalism_bundles_parent_id);
//     //var minimalism_bundles_parent_id = jQuery('#minimalism-bundles-parent-id').val();
//     //jQuery(form_selector).append('<input id="minimalism_bundle_parent_product_id" name="minimalism_bundle_parent_product_id" value="'+minimalism_bundles_parent_id+'" type="hidden"/></div>');

//     //jQuery('.shopify-product-form').append('<button class="minimalism_bundle_add_to_cart">Añadir al carrito Pack</button>');

//     //jQuery( form_selector ).submit(minimalism_bundle());
    
//     console.log('End for variants minimalism bundles');
//     //jQuery(button_selector).click(minimalism_bundle);
//   }
// }
// function wait(ms){
//    var start = new Date().getTime();
//    var end = start;
//    while(end < start + ms) {
//      end = new Date().getTime();
//   }
// }
// jQuery(document).ready(function () {
//   //Detect if is a bundle
//   var url = window.location.href;
//   /*var bundle_json_url = url + '?view=json';
//     fetch(bundle_json_url)
//       .then(res => res.json())
//       .then((out) => {
//           var bundle_json = out;
//           console.log('Output: ', out);
//   	}).catch(err => console.log(err,bundle_json_url));*/

//   //https://community.shopify.com/c/Shopify-Design/Adding-2-products-to-cart-with-1-add-to-cart-button/td-p/272910

//   minimalism_print_bundles_form();

//   /*CART*/

//   var firstChange = true;
//   function reloadCart() {
//     var target = document.querySelector(`[data-cart-subtotal]`);

//     if (!target) return;

//     var observer = new MutationObserver(function (mutations) {
//       mutations.forEach(function (mutation) {
//         if (firstChange) {
//           firstChange = false;
//           return;
//         } else {
//           setTimeout(window.location.reload(), 100);
//         }
//       });
//     });

//     var config = { attributes: true, childList: true, characterData: true };
//     observer.observe(target, config);
//   }
//   document.addEventListener("DOMContentLoaded", function () {
//     reloadCart();
//   });

//   //capa de carga

//   if(document.getElementById("minimalism-add-to-cart") && jQuery("#minimalism-bundles-data").val()) {

//   document.getElementById("minimalism-add-to-cart").addEventListener('click', function(e){
//     e.preventDefault();
//     //meto capa de carga
//     document.getElementById('minimalism-loagind-layer-bundles').style.display = 'block';
//     console.log(e);
    
//       setTimeout( function() {
// var cookie =
//         getCookie("minimalism-bundles-parent-id") +
//         "," +
//         jQuery("#minimalism-bundles-parent-id").val();
//       setCookie("minimalism-bundles-parent-id", cookie, 1);
      
    
      
//       //Quitamos el producto pack del carrito
//       jQuery.ajax({
//         type: "POST",
//         url: "/cart/change.js",
//         data: {
//           quantity: 0,
//           //tomamos el id del producto actual
//           id: jQuery(".shopify-product-form input[name=id]").val(),
//         },
//         async: true,
//       });

//       minimalism_bundle();
//       //borramos layer
//       //setTimeout( function() { location.href = current_lang_slug + "/cart"; }, 5000 );
//       //document.getElementById("minimalism-loagind-layer-bundles").remove();
//       location.href = current_lang_slug + "/cart";
        
//       }, 1000 );
      
      
    

//   },true)
// }
//   console.log('End on document load minimalism bundles');
// });

// console.log('End minimalism bundles');
